import {mapActions} from 'vuex'

const globalSearchHandler = () => ({
    loading: false,
    data: {},
    error: null
})

/**
 * Search mixin for using the global search endpoint.
 * @mixin
 */
export default {
    data: () => ({
        globalSearchHandler: globalSearchHandler()
    }),
    methods: {
        ...mapActions('search', ['globalSearch', 'resetSearch']),
        async handleGlobalSearch (data) {
            const vm = this

            try {
                vm.globalSearchHandler.loading = true

                const response = await vm.globalSearch(data)

                vm.globalSearchHandler.data = response
                vm.globalSearchHandler.error = null
            } catch (e) {
                vm.globalSearchHandler.error = e
                return Promise.reject(e)
            } finally {
                vm.globalSearchHandler.loading = false
            }
        },
        resetGlobalSearch () {
            const vm = this
            vm.resetSearch()
            vm.globalSearchHandler = globalSearchHandler()
        }
    }
}
